import { render, staticRenderFns } from "./UtgiftskategoriCard.vue?vue&type=template&id=97be5a46&scoped=true&"
import script from "./UtgiftskategoriCard.vue?vue&type=script&lang=js&"
export * from "./UtgiftskategoriCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be5a46",
  null
  
)

export default component.exports